import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { MaskLines } from "@/components/Reveal";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [state, setState] = useState("checking");
  const [orderId, setOrderId] = useState("");
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) {
      setState("error");
      return undefined;
    }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setOrderId(data?.order_id || "");
        if (data?.payment_status === "paid") {
          setState("paid");
          if (!cleared.current) { cleared.current = true; clear(); }
          return;
        }
        if (data?.status === "expired") return setState("error");
      } catch (e) { /* retry */ }
      tries += 1;
      if (tries < 10) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, clear]);

  return (
    <main data-testid="payment-success-page" className="mx-auto max-w-4xl px-5 pb-32 pt-40">
      <p className="eyebrow" data-testid="payment-status">{state === "paid" ? "Payment confirmed" : state === "checking" ? "Confirming payment…" : "Status unclear"}</p>
      {state === "paid" ? (
        <>
          <h1 className="mt-6 font-display text-6xl font-light leading-none md:text-8xl"><MaskLines lines={["Thank you.", "It's yours."]} lineClass="last:italic" /></h1>
          <p className="mt-8 text-stone">Order <span data-testid="order-id" className="font-mono text-ink">{orderId}</span> is confirmed. A receipt is on its way to your inbox.</p>
        </>
      ) : (
        <h1 className="mt-6 font-display text-5xl font-light">{state === "checking" ? "One moment…" : "We couldn't confirm your payment yet. Check your email for a receipt."}</h1>
      )}
      <Link to="/shop" data-testid="success-continue-link" className="mt-12 inline-flex rounded-full bg-ink px-7 py-4 text-sm text-bone">Continue browsing</Link>
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="mx-auto max-w-4xl px-5 pb-32 pt-40">
      <p className="eyebrow">Payment cancelled</p>
      <h1 className="mt-6 font-display text-6xl font-light">Your bag is <em>still here.</em></h1>
      <Link to="/checkout" data-testid="cancel-return-link" className="mt-12 inline-flex rounded-full bg-ink px-7 py-4 text-sm text-bone">Return to checkout</Link>
    </main>
  );
}
